import { createMuiTheme } from '@material-ui/core/styles'
const CustomTheme = createMuiTheme({
    direction: "rtl",
    typography: {
        fontFamily: "Vazir !important"
    }
})

export default CustomTheme